"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const Accordion_styles_1 = require("./Accordion.styles");
/**
 * @deprecated please use <Ds.Accordion> instead
 */
const Accordion = (_a) => {
    var { header, children, icon, extra, defaultOpen = false, openOnly = false } = _a, _b = _a.buttonProps, _c = _b === void 0 ? {} : _b, { onClick: onButtonClick } = _c, buttonProps = __rest(_c, ["onClick"]), props = __rest(_a, ["header", "children", "icon", "extra", "defaultOpen", "openOnly", "buttonProps"]);
    const [isOpen, setIsOpen] = (0, react_1.useState)(defaultOpen);
    const handleToggle = () => {
        setIsOpen((prevState) => !prevState);
    };
    const handleClick = (e) => {
        if (onButtonClick) {
            ((openOnly && !isOpen) || !openOnly) && onButtonClick(e);
        }
        handleToggle();
    };
    const handleKeyUp = (e) => {
        switch (e.key) {
            case "Escape":
                setIsOpen(false);
                break;
            default:
                break;
        }
    };
    return (react_1.default.createElement(Accordion_styles_1.StyledAccordion, Object.assign({}, props),
        react_1.default.createElement(Accordion_styles_1.StyledSummary, Object.assign({}, buttonProps, { type: "button", "aria-expanded": isOpen, onClick: handleClick, onKeyUp: handleKeyUp }),
            react_1.default.createElement(Accordion_styles_1.StyledSummaryLeft, null,
                icon && (react_1.default.createElement(__1.Icon, Object.assign({ size: 3 }, icon, { props: { "aria-hidden": "true" } }))),
                typeof header === "string" ? (react_1.default.createElement(__1.Text, { variant: "label", skinny: true }, header)) : (header)),
            react_1.default.createElement(Accordion_styles_1.StyledSummaryRight, { isOpen: isOpen },
                extra,
                react_1.default.createElement(__1.Icon, { size: 3, name: "Arrow", props: {
                        className: "icon-arrow",
                        "aria-hidden": "true",
                    } }))),
        isOpen && (react_1.default.createElement(Accordion_styles_1.StyledContent, { hasIcon: !!icon }, typeof children === "string" ? (react_1.default.createElement(__1.Text, { skinny: true }, children)) : (children)))));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map